import { useContext, useEffect } from 'react'
import { MapContext } from '../component'
import { AnySourceData } from 'mapbox-gl'

export const Source = ({
  sourceId,
  options
}: {
  sourceId: string
  options: AnySourceData
}) => {
  const map = useContext(MapContext)
  useEffect(() => {
    if (map) {
      map.on('load', () => {
        map.addSource(sourceId, options)
      })
    }
  }, [])

  return null
}
